import { ViewModel, View } from "binder"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { stringIsNullOrEmpty, translate } from "src/common/utilities";
import { PersonnelSearchViewModel } from "src/erp/enterpriseAdministration/humanResource/personnel/personnelSearch/personnelSearch-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { IUser } from "../iUser";
import { UserEditorView } from "./userEditor-view"

export class UserEditorViewModel extends ViewModel implements IUser, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);

        this.personnelSelector = new PersonnelSearchViewModel(this);
        this.personnelSelector.placeholder = translate("userEditor-viewModel.personnelCode", {});
        this.personnelSelector.onSelectionChanged = x => {
            this.personnelCode = x.code;
            this.personnelFullName = `${x.name} ${x.lastName}`;
            this.personnelId = x.id;
        }
        this._updater = updater;
    }
    closePopup(result?: any) {
    }
    GetDefaultView(): View<ViewModel> {
        return new UserEditorView();
    }
    public getTypeId(): string {
        return "VM-09067201-6CB7-4247-8929-220307D0E35F"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set username(v: string) { this._username = v; } public get username(): string { return this._username; } private _username: string;
    public set personnelId(v: string) { this._personnelId = v; } public get personnelId(): string { return this._personnelId; } private _personnelId: string;
    public set password(v: string) { this._password = v; } public get password(): string { return this._password; } private _password: string;
    public set repeatPassword(v: string) { this._repeatPassword = v; } public get repeatPassword(): string { return this._repeatPassword; } private _repeatPassword: string;
    public set personnelSelector(v: PersonnelSearchViewModel) { this._personnelSelector = v; } public get personnelSelector(): PersonnelSearchViewModel { return this._personnelSelector; } private _personnelSelector: PersonnelSearchViewModel;
    public set personnelFullName(v: string) { this._personnelFullName = v; } public get personnelFullName(): string { return this._personnelFullName; } private _personnelFullName: string;
    public set personnelCode(v: string) { this._personnelCode = v; } public get personnelCode(): string { return this._personnelCode; } private _personnelCode: string;


    getPassword(): string {
        return this.password;
    }

    private _updater: IServerUpdater;

    cloneTo(user: IUser) {
        user.id = this.id;
        user.username = this.username;
        user.personnelId = this.personnelId;
    }
    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), translate("userEditor-viewModel.registrationError", {}));
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._updater.execute(this);
                if (result.IsSuccessful) {
                    await this.messageBoxConfirmSuccess(translate("userEditor-viewModel.successfullyRegistered", {}), translate("userEditor-viewModel.successfulOperation", {}));
                    this.closePopup(this);
                } else if (result.Faults && result.Faults[0] && result.Faults[0].Parameters && result.Faults[0].Parameters.FaultId == 'E3637FF9-1CC5-437D-9C4B-5DF2786E376D') {
                    await this.messageBoxConfirmWarning(translate("userEditor-viewModel.duplicateUserName", {}), translate("userEditor-viewModel.operationErorr", {}));
                } else {
                    await this.messageBoxConfirmWarning(translate("userEditor-viewModel.registrationError", {}), translate("userEditor-viewModel.operationErorr", {}));
                }
            } catch (ex) {
                console.log(ex);
                await this.messageBoxConfirmWarning(translate("userEditor-viewModel.registrationError", {}), translate("userEditor-viewModel.operationErorr", {}));
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.username)) {
            result.push(translate("userEditor-viewModel.userNameError", {}));
        }
        if (stringIsNullOrEmpty(this.password)) {
            result.push(translate("userEditor-viewModel.passwordError", {}));
        }
        if (stringIsNullOrEmpty(this.repeatPassword)) {
            result.push(translate("userEditor-viewModel.repeatPasswordError", {}));
        }
        if (this.password !== this.repeatPassword && !stringIsNullOrEmpty(this.repeatPassword)) {
            result.push(translate("userEditor-viewModel.The password and its repetition are not the same.", {}));
        }
        if (this.personnelSelector.selectedItem == null) {
            result.push(translate("userEditor-viewModel.personnelError", {}));
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(personnel: IUser): Promise<any>;
}


export class UserInserter implements IServerUpdater {
    async execute(user: IUser): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/SecurityRawDataServices/CreateUser', {
                PersonnelId: user.personnelId,
                Username: user.username,
                Password: user.getPassword()
            });

            return result;
        } catch (ex) {
            throw ex;
        } finally {
        }
    }

}